import { ReactNode, useMemo } from "react";
import { Ruleset } from "../../domain/ruleset";
import { RulesetContext } from "./context";

import latest from "../../rulesets/latest.json";
import { useDatabase } from "../database-provider";

export function RulesetProvider(props: { children: ReactNode }) {
  const db = useDatabase();
  const ruleset = useMemo(() => new Ruleset(latest, db), [db]);

  return (
    <RulesetContext.Provider value={ruleset}>
      {props.children}
    </RulesetContext.Provider>
  );
}
